export enum AssessmentFlow {
  landing,
  survey,
  summary,
  complete
}

export enum TemplateAccessStep {
  manager,
  template,
  department,
  resource,
  site,
  thirdParty,
  summary
}
